import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { Router } from '@angular/router';
import { PageType } from 'src/app/services/pageTypes';
import { ApiService } from 'src/app/services/api.service';
import { JobService } from 'src/app/services/job.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';

@Component({
  selector: 'app-invite-colleagues',
  standalone: true,
  imports: [CommonModule, NG_ICON_DIRECTIVES],
  templateUrl: './invite-colleagues.component.html',
  styleUrls: ['./invite-colleagues.component.scss']
})
export class InviteColleaguesComponent implements OnInit {
  stats = { sent: 0, accepted: 0 };

  photo: string | null = null;
  initials = '';
  initialsBg = '#8B5CF6';
  initialsColor = '#FFFFFF';

  constructor(
    private router: Router,
    private pageType: PageType,
    private api: ApiService,
    private jobService: JobService,
  ) {}

  ngOnInit() {
    const userId = localStorage.getItem('userId');
    if (!userId) return;
    this.fetchReferralCounts(userId);
    this.api.query('user/profile/complete/' + userId).subscribe(
      (res: any) => {
        if (!res) return;
        const first = res.firstName || '';
        const last = res.lastName || '';
        this.initials = this.jobService.getInitialsparam(first, last);
        this.initialsBg = this.jobService.getColorparam(first, last);
        this.initialsColor = this.jobService.getTextColor(first, last);
        const p: string | undefined = res.photo;
        if (p && p !== 'null' && p !== '') {
          this.photo = (p.startsWith('http://') || p.startsWith('https://'))
            ? p
            : AppSettings.photoUrl + p;
        }
      },
      () => {}
    );
  }

  /** Live invite/accepted counts — same endpoint the referrals page uses
   *  (`ReferralsComponent.getinviteData`). `totalCount` → sent,
   *  `acceptedCount` → accepted. Falls back to 0 on failure. */
  private fetchReferralCounts(userId: string) {
    const data = { screenType: GigsumoConstants.IN_APP, userId };
    this.api.create('home/getReferralCountsAndPoints', data).subscribe(
      (res: any) => {
        if (res?.code === '00000' && res.data) {
          this.stats = {
            sent: res.data.totalCount ?? 0,
            accepted: res.data.acceptedCount ?? 0,
          };
        }
      },
      () => {}
    );
  }

  routeToReferal() {
    const params = {
      userId: localStorage.getItem('userId'),
      plan: localStorage.getItem('MemberShipType'),
      businessName: localStorage.getItem('currentOrganization'),
      businessEmail: localStorage.getItem('userName'),
      bid: localStorage.getItem('GSSID'),
    };
    this.router.navigate(['user-management/referral'], { queryParams: params });
    setTimeout(() => {
      this.pageType.setPageName({ pages: 'referrals' });
    }, 2000);
  }
}
